import {
  WiseOwlBlock,
  WiseOwlBlockType,
  WiseOwlBlockDisplayType,
  wiseOwlViewCopy,
  WiseOwlLoadingConfiguration,
  WiseOwlEventEnumType,
  WiseOwlEventEnum,
} from '@twiliointernal/org/twilio/e2-commons/shared/definitions';

const WO_DISPLAY_NAME = 'Help Center Assistant';
const LOG_PREFIX = '[WiseOwlView]';
const WISE_OWL_CHAT_HEIGHT = '70vh';
const WISE_OWL_CHAT_MIN_HEIGHT = '625px';

/**
 * These exact prompts are subject to change, and the way we
 * determine these prompts will change post-MLP, where they'll no longer be static
 * consider this temporary.
 */
const recommendedPrompts: WiseOwlBlock[] = [
  {
    type: WiseOwlBlockType.PromptSuggestionGroup,
    display: WiseOwlBlockDisplayType.Persistent,
    values: {
      categories: [
        {
          name: wiseOwlViewCopy.defaultPromptSuggestions.startingWithTwilio
            .name,
          suggestions: [
            wiseOwlViewCopy.defaultPromptSuggestions.startingWithTwilio
              .suggestions.first,
            wiseOwlViewCopy.defaultPromptSuggestions.startingWithTwilio
              .suggestions.second,
            wiseOwlViewCopy.defaultPromptSuggestions.startingWithTwilio
              .suggestions.third,
          ],
        },
        {
          name: wiseOwlViewCopy.defaultPromptSuggestions.accountHelp.name,
          suggestions: [
            wiseOwlViewCopy.defaultPromptSuggestions.accountHelp.suggestions
              .first,
            wiseOwlViewCopy.defaultPromptSuggestions.accountHelp.suggestions
              .second,
            wiseOwlViewCopy.defaultPromptSuggestions.accountHelp.suggestions
              .third,
          ],
        },
      ],
    },
  },
];

const preChat = {
  // link to quick start guide
  href: 'https://help.twilio.com/articles/18133722687643',
  recommendedPrompts,
};

const defaultLoadingState: WiseOwlLoadingConfiguration = {
  submission: false,
  fetchChatById: false,
};

const errorLogMessageToEventTypeMap: Record<WiseOwlEventEnumType, string> = {
  [WiseOwlEventEnum.getChat]: `${LOG_PREFIX}::Error fetching chat`,
  [WiseOwlEventEnum.getChatSummary]: `${LOG_PREFIX}::Chat summary failed`,
  [WiseOwlEventEnum.liveChat]: `${LOG_PREFIX}::Live chat engagement failed`,
  [WiseOwlEventEnum.loginRedirect]: `${LOG_PREFIX}::Login redirect failed`,
  [WiseOwlEventEnum.phoneSupport]: `${LOG_PREFIX}::Phone support engagement failed`,
  [WiseOwlEventEnum.redirect]: `${LOG_PREFIX}::Redirect failed`,
  [WiseOwlEventEnum.sendChatMessage]: `${LOG_PREFIX}::Message send failed`,
  [WiseOwlEventEnum.sendChatMessageRetry]: `${LOG_PREFIX}::`,
  [WiseOwlEventEnum.startNewChat]: `${LOG_PREFIX}::Chat creation failed`,
  [WiseOwlEventEnum.startNewChatRetry]: `${LOG_PREFIX}::Retry start new chat failed`,
  [WiseOwlEventEnum.streamComplete]: `${LOG_PREFIX}::Document stream completion failed`,
  [WiseOwlEventEnum.streamError]: `${LOG_PREFIX}::Document stream failed`,
  [WiseOwlEventEnum.streamInitialize]: `${LOG_PREFIX}::Document steam initialization failed`,
  [WiseOwlEventEnum.submitFeedback]: `${LOG_PREFIX}::Create feedback failed`,
  [WiseOwlEventEnum.submitTicket]: `${LOG_PREFIX}::Ticket submission engagement failed`,
};

const logMessageToEventTypeMap: Record<WiseOwlEventEnumType, string> = {
  [WiseOwlEventEnum.getChat]: `${LOG_PREFIX}::Fetched chat`,
  [WiseOwlEventEnum.getChatSummary]: `${LOG_PREFIX}::Getting Wise Owl chat summary`,
  [WiseOwlEventEnum.sendChatMessage]: `${LOG_PREFIX}::Updating Wise Owl chat`,
  [WiseOwlEventEnum.sendChatMessageRetry]: `${LOG_PREFIX}::Retry send chat message`,
  [WiseOwlEventEnum.startNewChat]: `${LOG_PREFIX}::Creating Wise Owl chat`,
  [WiseOwlEventEnum.startNewChatRetry]: `${LOG_PREFIX}::Retry start new chat `,
  [WiseOwlEventEnum.streamComplete]: `${LOG_PREFIX}::Document sync completed`,
  [WiseOwlEventEnum.streamInitialize]: `${LOG_PREFIX}::Document sync initialized`,
  [WiseOwlEventEnum.submitFeedback]: `${LOG_PREFIX}::Creating message feedback`,
};

export {
  WO_DISPLAY_NAME,
  WISE_OWL_CHAT_HEIGHT,
  WISE_OWL_CHAT_MIN_HEIGHT,
  LOG_PREFIX,
  defaultLoadingState,
  preChat,
  errorLogMessageToEventTypeMap,
  logMessageToEventTypeMap,
};
